import BaseModel from "../default/base-model";

export class FtBomGroup extends BaseModel {
    id?: number;
    code: string;
    description?: string;
    url: string;

    constructor() {
        super();
        this.id = undefined;
        this.code = "";
        this.description = "";
        this.url = "";
    }
}
